module.exports = __webpack_public_path__ + "img/windows.8e965cfe.svg";